import type { CSSProperties } from 'react';
import type { ColorTextAlias } from '@pv-frontend/design-tokens';
import { vars } from '../../theme/contract.css';
import { spinner } from './spinner.css';

export interface SpinnerProps {
    size?: 'small' | 'large';
    tone?: ColorTextAlias;
    /** Accessible label announced to screen readers. */
    accessibilityLabel?: string;
    testID?: string;
}

export function Spinner({ size = 'small', tone = 'text-primary', accessibilityLabel = 'Loading', testID }: SpinnerProps) {
    const dimension = size === 'large' ? 28 : 16;
    const style: CSSProperties = {
        width: dimension,
        height: dimension,
        borderWidth: size === 'large' ? 3 : 2,
        color: vars.color[tone],
    };
    return (
        <span
            className={spinner}
            style={style}
            role="status"
            aria-label={accessibilityLabel}
            data-testid={testID}
        />
    );
}
